import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCartStore } from '../features/cart/useCartStore';

/**
 * Bottom Navigation Bar — custom 100% CSS Vanilla.
 * 5 tab-uri cu SVG icons + label + badge coș.
 * Konsta Tabbar a fost înlocuit deoarece necesita Tailwind intern.
 */

interface NavTab {
  path: string;
  label: string;
  icon: (active: boolean) => React.ReactNode;
  exact?: boolean;
}

const TABS: NavTab[] = [
  {
    path: '/',
    label: 'Acasă',
    exact: true,
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    path: '/produse',
    label: 'Produse',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" fill={active ? 'currentColor' : 'none'} />
        <rect x="14" y="3" width="7" height="7" fill={active ? 'currentColor' : 'none'} />
        <rect x="14" y="14" width="7" height="7" fill={active ? 'currentColor' : 'none'} />
        <rect x="3" y="14" width="7" height="7" fill={active ? 'currentColor' : 'none'} />
      </svg>
    ),
  },
  {
    path: '/cos',
    label: 'Coș',
    icon: (_active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </svg>
    ),
  },
  {
    path: '/favorite',
    label: 'Favorite',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    path: '/cont',
    label: 'Cont',
    icon: (active) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" fill={active ? 'rgba(11,110,95,0.15)' : 'none'} />
        <circle cx="12" cy="7" r="4" fill={active ? 'rgba(11,110,95,0.15)' : 'none'} />
      </svg>
    ),
  },
];

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  // Selector direct pe cantitate — evită re-randarea la orice altă schimbare din store
  const cartCount = useCartStore((s) =>
    s.items.reduce((sum, item) => sum + item.quantity, 0)
  );

  const handleNavigate = useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  return (
    <nav className="dds-bottom-nav" aria-label="Navigare principală">
      {TABS.map((tab) => {
        const isActive = tab.exact
          ? location.pathname === tab.path
          : location.pathname.startsWith(tab.path);

        return (
          <button
            key={tab.path}
            className={`dds-bottom-nav-item ${isActive ? 'dds-bottom-nav-item--active' : ''}`}
            onClick={() => handleNavigate(tab.path)}
            aria-label={tab.label}
          >
            <span className="dds-bottom-nav-icon">
              {tab.icon(isActive)}
              {tab.path === '/cos' && cartCount > 0 && (
                <span className="dds-bottom-nav-badge">
                  {cartCount > 9 ? '9+' : cartCount}
                </span>
              )}
            </span>
            <span className="dds-bottom-nav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNav;
